import { useDecision } from '@optimizely/react-sdk';
import { useTrackOptimizely } from '@fff-web/fff-analytics';
import useActiveSubscriptionState from '../components/welcome/useActiveSubscriptionState';
import { CANCELLED_BOX_REFILL_RETENTION } from '../utils/canceled_box_refills_retention';

export const useRefillsRetentionExperiment = () => {
  const hasActiveSubscription = useActiveSubscriptionState();
  const [cancelledBoxDecision] = useDecision(CANCELLED_BOX_REFILL_RETENTION.FEATURE_FLAG);

  const activeExperiment =
    cancelledBoxDecision.enabled &&
    cancelledBoxDecision.variationKey === CANCELLED_BOX_REFILL_RETENTION.VARIATION_A;

  const showExperiment = hasActiveSubscription && activeExperiment;
  const shouldTrackEvent = hasActiveSubscription && cancelledBoxDecision.enabled;

  useTrackOptimizely(cancelledBoxDecision, cancelledBoxDecision?.ruleKey || '', shouldTrackEvent);

  return {
    showExperiment,
  };
};
